import axios, { AxiosError } from 'axios';
import { logOutIfTokenExpired, resultInfo } from 'Components/helpers';
import { t } from 'i18next';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BaseApi from 'shared/api';
import Swal from 'sweetalert2';

export function useCreateFavFolder({
   token,
   apiKey,
   onSuccess,
   onError,
}: {
   token: string;
   apiKey: string;
   onError?: () => void;
   onSuccess?: () => void;
}) {
   const { t } = useTranslation('global');
   const navigate = useNavigate();
   const [folderName, setFolderName] = useState('');
   const [loading, setLoading] = useState(false);

   const onCreateFolder = async () => {
      try {
         setLoading(true);

         const response = await axios.post(
            BaseApi + '/folder/create',
            {
               name: folderName,
            },
            {
               headers: {
                  key: apiKey,
                  token: token,
                  contentType: 'application/json',
               },
            }
         );

         setLoading(false);

         if (response.status === 200) {
            setFolderName('');
            onSuccess?.();
         } else {
            Swal.fire({
               icon: 'error',
               text: response.data.message,
               title: t('employerFavouriteList.createFolderFailedTitle'),
               confirmButtonText: t('employerFavouriteList.close'),
            });
            onError?.();
         }
      } catch (error: any) {
         setLoading(false);

         if (
            error.message === 'Network Error' ||
            error.response.data.message === 'Token has expired'
         ) {
            navigate('/');

            logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
         } else {
            Swal.fire({
               icon: 'error',
               text: t('employerFavouriteList.folderFailedTxt'),
               confirmButtonText: t('employerFavouriteList.close'),
               title: t('employerFavouriteList.createFolderFailedTitle'),
            });
         }

         console.error("Couldn't create the folder!", error);
      }
   };

   return { onCreateFolder, createFolderLoading: loading, folderName, setFolderName };
}
